<template>
  <!--头部开始-->
  <section class="developer-header">
    <header class="head">
      <h1 class="logo-box">
        <a class="logo-link" href="#">
          <img class="logo-image" src="./img/logo.png" alt="logo"/>
        </a>
      </h1>
      <p class="head-desc">创造与魔法开发者管理系统</p>
    </header>
  </section>
  <!--头部结束-->
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'developerHeader'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "developerHeader.styl";
</style>



// WEBPACK FOOTER //
// src/components/developerHeader/developerHeader.vue